import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import 'style/layout/Forms.css';

export default ({
  id,
  label,
  onChange,
  name,
  required,
  options,
  value,
  className,
  disabled,
}: {
  id: string;
  label?: string;
  onChange: any;
  name?: string;
  required?: boolean;
  options: any;
  value: any;
  className?: string;
  disabled?: boolean;
}): JSX.Element => {
  return (
    <FormGroup>
      {label ? (
        <Label className="label" for={id}>
          {label}
        </Label>
      ) : (
        ''
      )}
      <Input
        className={`text-field ${className}`}
        id={id}
        name={name}
        onChange={onChange}
        required={required === undefined ? false : required}
        type="select"
        value={value}
        disabled={disabled == null ? false : disabled}
      >
        {options}
      </Input>
    </FormGroup>
  );
};
